import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DefaultEndUserRequest, EndUser } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class DefaultsResource {
  private http = inject(HttpClient);

  endUserDefaults(body: DefaultEndUserRequest): Observable<EndUser> {
    return this.http.post<EndUser>(`/services/cisco/defaults/end-user`, {
      ...body,
    });
  }
}
